import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { renoworksPrimaryPalette, renoworksSecondaryPalette, themeConstants } from './theme.constants';

const { WHITE, BLACK, fontSize, htmlFontSize } = themeConstants;

// This method is available AFTER theme is created. This is same logic so we can
// use as part of making the theme
const pxToRem = (size: number) => `${(size / htmlFontSize) * (fontSize / htmlFontSize)}rem`;

export const theme = responsiveFontSizes(
  createTheme({
    palette: {
      common: {
        white: WHITE,
        black: BLACK,
      },
      background: {
        paper: WHITE,
        default: '#f5f5f5',
      },
      primary: renoworksPrimaryPalette,
      secondary: renoworksSecondaryPalette,
      error: {
        main: '#d63e3e',
        contrastText: WHITE,
      },
      success: {
        main: '#61ed77',
      },
      text: {
        primary: BLACK,
        secondary: '#747474',
        disabled: '#aeaeae',
      },
    },
    typography: {
      fontSize,
      htmlFontSize,
      fontFamily: 'public-sans, sans-serif',
      h1: {
        fontWeight: 700,
        fontSize: pxToRem(96),
        letterSpacing: pxToRem(1),
      },
      h2: {
        fontWeight: 700,
        fontSize: pxToRem(60),
        letterSpacing: pxToRem(1),
      },
      h3: {
        fontWeight: 700,
        fontSize: pxToRem(48),
      },
      h4: {
        fontWeight: 700,
        fontSize: pxToRem(34),
        textTransform: 'uppercase',
      },
      h5: {
        fontWeight: 500,
        fontSize: pxToRem(24),
      },
      h6: {
        fontWeight: 500,
        fontSize: pxToRem(20),
      },
      subtitle1: {
        fontWeight: 500,
        fontSize: pxToRem(16),
        letterSpacing: pxToRem(1),
      },
      subtitle2: {
        fontWeight: 500,
        fontSize: pxToRem(14),
        textTransform: 'uppercase',
        letterSpacing: pxToRem(1),
      },
      body1: {
        fontSize: pxToRem(16),
      },
      body2: {
        fontSize: pxToRem(14),
      },
      button: {
        fontSize: pxToRem(14),
        textTransform: 'uppercase',
        letterSpacing: pxToRem(1),
      },
      caption: {
        fontSize: pxToRem(12),
      },
      overline: {
        fontWeight: 400,
        fontSize: pxToRem(10),
        letterSpacing: pxToRem(1),
        textTransform: 'uppercase',
      },
    },
    components: {
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            // This is defaulting to `uppercase`
            textTransform: 'none',
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          sizeMedium: {
            color: '#faab19',
          },
        },
      },
    },
  })
);